"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestTokenFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var TestTokenFactory = /** @class */ (function (_super) {
    __extends(TestTokenFactory, _super);
    function TestTokenFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    TestTokenFactory.prototype.deploy = function (name, symbol, decimals, overrides) {
        return _super.prototype.deploy.call(this, name, symbol, decimals, overrides || {});
    };
    TestTokenFactory.prototype.getDeployTransaction = function (name, symbol, decimals, overrides) {
        return _super.prototype.getDeployTransaction.call(this, name, symbol, decimals, overrides || {});
    };
    TestTokenFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    TestTokenFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    TestTokenFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return TestTokenFactory;
}(contracts_1.ContractFactory));
exports.TestTokenFactory = TestTokenFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "decimals",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "PERMIT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "approveOnBehalf",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "approvedCollateral",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "mintShare",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "permit",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "redeemShare",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=TestTokenFactory.js.map